import { apiClient } from '@/services/api.service'

const OrderService = {
  getOrdersByQuery: (params) => apiClient().get('/v1/admin/orders', { params }),
  overrideOrderByCSR: (identifier) => apiClient().put(`/v1/admin/orders/${encodeURIComponent(identifier)}`)
}

export default OrderService
